import { RadioGroupProps } from "./RadioGroupProps";
import { RadioGroupContext } from "./RadioGroupContext";
import { clsx } from "clsx";
import classes from "./Radio.module.scss";

export function RadioGroup(props: RadioGroupProps) {
  const {
    children,
    direction = "row",
    className,
    name,
    value,
    onChange,
    defaultValue,
    layout,
  } = props;

  return (
    <div
      className={clsx(
        classes.radioGroup,
        {
          [classes.columnDireccion]: direction === "column",
          [classes.gridLayout]: layout === "grid",
          [classes.autoFitLayout]: layout === "auto-fit",
          [classes.autoFitLayoutLarge]: layout === "auto-fit-large",
        },
        className,
      )}
    >
      <RadioGroupContext.Provider
        value={{ value, defaultValue, onChange, name }}
      >
        {children}
      </RadioGroupContext.Provider>
    </div>
  );
}
